import React, { useState, useEffect } from 'react';
import P, { InferProps } from 'prop-types';
import TextField from '@mui/material/TextField';

function DateTimeField({
  setChange,
  setValidation,
  field,
  isReadOnly,
  hideValidationError,
  fullWidth,
}: InferProps<typeof DateTimeField.propTypes>) {
  const [value, setValue] = useState(field.value);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isDirty, setIsdirty] = useState(false);

  useEffect(() => {
    setValue(field.value);
  }, [field.value]);

  useEffect(() => {
    const validate = async (newValue: string | null | undefined) => {
      const yupSchema = field.validation;

      try {
        await yupSchema.validate(newValue);
        setErrorMessage('');
      } catch (error: any) {
        if (isDirty || !hideValidationError) {
          setErrorMessage(error.message);
        }
      } finally {
        setValidation(field.key, newValue, field.validation);
      }
    };

    validate(value);
  }, [hideValidationError, field, isDirty, setValidation, value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setValue(value);
    setChange(field.key, value, field.validation, field.isTeamDataValue);
    setIsdirty(true);
  };

  return (
    <TextField
      type="datetime-local"
      slotProps={{
        inputLabel: {
          shrink: true,
        },
      }}
      disabled={field.key === 'Not available' || !!isReadOnly}
      value={value}
      onChange={handleChange}
      id={field.id}
      label={field.title}
      helperText={errorMessage}
      error={!!errorMessage}
      variant="outlined"
      fullWidth={fullWidth || false}
    />
  );
}

DateTimeField.propTypes = {
  field: P.shape({
    title: P.string.isRequired,
    id: P.string.isRequired,
    type: P.string,
    validation: P.any,
    key: P.string,
    value: P.string,
    isTeamDataValue: P.bool,
  }).isRequired,
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  isReadOnly: P.bool,
  hideValidationError: P.bool,
  fullWidth: P.bool,
};

export default React.memo(DateTimeField);
